var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApiKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 490 490"
    },
    viewBox: "0 0 490 490",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.128 391.35c28.956 14.485 108.595 35.571 156.385 31.62 47.79-3.951 124.52-67.175 139.005-88.245 14.485-21.07-18.819-23.703-52.123-6.584s-140.445 51.373-191.128 0c0 0 117.277 10.535 121.626 0 4.349-10.535-13.031-27.654-104.246-47.422-91.215-19.753-156.385 0-156.385 0v126.449c-.016-.015 57.911-30.303 86.866-15.818zM0 280.704h69.503v135.698H0zm203.838-61.035c28.313 0 52.812-15.634 66.057-38.541l182.982 47.192 7.656-29.66-22.662-5.849 13.107-50.531-29.629-7.687-13.107 50.577-26.766-6.906 12.832-51.358-29.691-7.426-12.786 51.143-72.32-18.65c.352-2.94.903-5.834.903-8.866 0-42.216-34.345-76.562-76.562-76.562-42.216 0-76.562 34.345-76.562 76.562.001 42.216 34.347 76.562 76.548 76.562zm0-122.499c25.327 0 45.937 20.61 45.937 45.937s-20.61 45.937-45.937 45.937c-25.327 0-45.937-20.61-45.937-45.937s20.61-45.937 45.937-45.937z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiKeyIcon);
export default __webpack_public_path__ + "static/media/api-key-icon.924ed87e4eac9b6a5a435545d40fb7c1.svg";
export { ForwardRef as ReactComponent };